(function(){
	var nzpost = {
		selectedAddress: {},
		availableAddresses: [],
		addressFields: {},
		addressesListSelector: '#nz-post-addresses-list',
		displayAddresses: function(addresses){
			this.clearAddressesList();
			for(var address = 0, addressesLen = addresses.length; address < addressesLen; address++){
				var currentAddress = addresses[address];
				var formattedAddress = this.getHTMLFormattedAddress(currentAddress, true);

				// add the addresses list
				$(this.addressesListSelector).append(formattedAddress);
			}
			this.showAddressList();
		},
		getHTMLFormattedAddress: function(address, collapsed){
			var html = '<li class="address" data-address-id="'+address.id+'"><span class="glyphicon map-marker glyphicon-map-marker"></span> <span class="address-details">'+address.address+'</span></li>';
			return html;
		},
		setClickHandler: function(callback){
			$(this.addressesListSelector + ' li.address').click(function(){
				// hide the menu and set the attribute
				var addressId = $(this).data('addressId');
				callback(addressId);
			});
		},
        hideAddressList: function(){
		    $(this.addressesListSelector).hide();
        },
        showAddressList: function(){
            $(this.addressesListSelector).show();
        },
		clearAddressesList: function(addresses){
			// clear out all list children
			this.hideAddressList();
			$(this.addressesListSelector).children().remove();
		},
		clearAddressFields: function(){
			document.getElementById(this.addressFields.streetAddressId).value = '';
			document.getElementById(this.addressFields.suburbId).value = '';
			document.getElementById(this.addressFields.cityId).value = '';
			document.getElementById(this.addressFields.postcodeId).value = '';
			document.getElementById(this.addressFields.streetNumberId).value = '';
			document.getElementById(this.addressFields.streetNameId).value = '';
			document.getElementById(this.addressFields.streetTypeId).value = '';
		},
		selectAddress: function(address){
			document.getElementById(this.addressFields.streetAddressId).value = this.selectedAddress.streetAddress;
			document.getElementById(this.addressFields.suburbId).value = this.selectedAddress.suburb;
			document.getElementById(this.addressFields.cityId).value = this.selectedAddress.city;
			document.getElementById(this.addressFields.postcodeId).value = this.selectedAddress.postcode;
			document.getElementById(this.addressFields.countryId).value = this.selectedAddress.country;
		},
		setAddressFields: function(streetAddressId, suburbId, cityId, postcodeId, countryId){
			this.addressFields.streetAddressId = streetAddressId;
			this.addressFields.suburbId = suburbId;
			this.addressFields.cityId = cityId;
			this.addressFields.postcodeId = postcodeId;
			this.addressFields.countryId = countryId;
		},
		asOneLine: function(address, collapsed){
		    collapsed = typeof collapsed !== 'undefined' ? collapsed : false;
			var output = '';
			if(address.poBox.length > 0){
				output = 'PO Box ' + address.poBox;
			}
			function addCommaAppropriatedField(field){
				if(output.length > 0 && field.length > 0){
					output += ', ';
				}
				output += field;
			}
			addCommaAppropriatedField(address.streetAddress);
			addCommaAppropriatedField(address.suburb);
			addCommaAppropriatedField(address.city);
			addCommaAppropriatedField(address.postcode);
			if(collapsed){
				output = this.collapseAddress(output);
			}
			return output;
		},
		collapseAddress: function(address){
		    var tmpAddress = address;
		    if(address.length > 40){
		        tmpAddress = address.substr(0,37) + '...';
            }
            return tmpAddress;
        }
	};
	window.nzpost = nzpost;
})();